// import {
//     DIC
// } from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const returnOrderOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    //viewBtn: true,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "退货单编号",
            prop: "returnOrderNum",
            type: "input",
            width:"200",
            addVisdiplay: false,
            editVisdiplay: false
        },{
            label: "进货商",
            prop: "proposerName",
            type: "input",
            width:"200",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "进货商联系人",
            prop: "contactsName",
            search: true,
            type: 'input'
        },
        {
            label: "进货商联系电话",
            prop: "contactsMobile",
            width:"110",
            type: 'input'
        },
        {
            label: "退货单状态",
            prop: "status",
            type: "input",
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {

            label: "供货商",
            prop: "supplierName",
            hide: true,
            solt: true,
            formsolt: true
        },
        {
            label: "供货商联系电话",
            prop: "supplierMobile",
            hide: true,
            solt: true,
            formsolt: true
        }, {
            label: "配送商",
            prop: "distributorName",
            search: true,
            type: 'input'
        },
        {
            label: "配送商联系电话",
            prop: "distributorMobile",
            width:"110",
            type: 'input'
        },
        {
            label: "申请时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            width:"100",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "创建人",
        //     prop: "createBy",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "状态",
        //     prop: "status",
        //     type: "radio",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.STATE
        // },
        // {
        //     label: "更新时间",
        //     prop: "updateTime",
        //     type: "datetime",
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "更新人",
        //     prop: "updateBy",
        //     type: "input",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "是否删除",
        //     prop: "deleteFlag",
        //     type: "radio",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.DELETE_FLAG
        // },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            span: 24,
            max: 255
        }
    ]
};